import { useAuthStore } from "../stores/authStore";
import { deviceRoot } from "../vue-client";

export async function calibrationCallFunction(param, functionName, slotId) {
    const authStore = useAuthStore();
    let authString = "Bearer " + authStore.authUser.authToken;
    const response = await fetch(`${deviceRoot}/functions/${slotId}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: authString,
        },
        body: JSON.stringify({
            function: functionName,
            param: param,
        }),
    });

    return response;
}

export async function callCalibarationAwakeFunction(minutes, slotId) {
    const response = await calibrationCallFunction(minutes, 'calAwakeMins', slotId);
    if (response.ok === true) {
        return `StayAwakeMin ${minutes} completed`;
    }
    else {
        const errorText = await response.text();
        return `StayAwakeMin ${minutes} failed. Error=${errorText}`;
    }
}

export async function pingDevice(slotId) {
    const authStore = useAuthStore();
    let authString = "Bearer " + authStore.authUser.authToken;
    const response = await fetch(`${deviceRoot}/slots/${slotId}/ready`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: authString,
        }
    });

    const responseJson = await response.json();
    return responseJson;
}

/**
 * 
 * @param rgbOption 0: R. 1: G. 2: B.
 * @param slotId string
 */
export async function callCalibrationFunction(rgbOption, slotId) {
    const response = await calibrationCallFunction(rgbOption, 'calRGB', slotId);
    if (response.ok === true) {
        return `Calibration completed`;
    }
    else {
        const errorText = await response.text();
        return `Calibration failed. Error=${errorText}`;
    }
}